import { Injectable } from '@angular/core';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { AuthenticationService } from 'src/modules/sm-base/services/authentication.service';
import { Additive } from '../shared/additive.entity';
import { CustomsNumber } from '../shared/customsNumber.entity';

@Injectable({
    providedIn: 'root'
})
export class RungisSupplierService {

    constructor(public authenticationService: AuthenticationService) {
    }

    async getCustomsNumbers(): Promise<CustomsNumber[]> {
        return RestEndpoint.main().run("api/run/customsNumber").list(CustomsNumber);
    }

    async getAdditives(): Promise<Additive[]> {
        return RestEndpoint.main().run("api/run/additives/frontend").list(Additive);
    }
}